import { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { AppToaster } from "web_myplann/Shared/Toaster/AppToaster";
import "./useToaster.css";

export const useToaster = () => {
	useEffect(() => {
		const toasterElement = document.createElement("div");

		document.body.appendChild(toasterElement);
		const root = createRoot(toasterElement);
		root.render(<AppToaster />);

		return () => {
			// Defer unmount to avoid interfering with concurrent render
			queueMicrotask(() => {
				root.unmount();
				toasterElement.remove();
			});
		};
	}, []);
};
